import shiva from '../Images/Testimonials/shiva_rep.png';
import ganganna from '../Images/Testimonials/ganganna_rep.png';
import durga from'../Images/Testimonials/durga_rep.png';
import sunil from "../Images/Testimonials/sunil_rep.png";

export const testimonials = [
    {
        name:"Shiva",
        place:"Khammam",
        pic:shiva,
        message:`I run two EC poultry farms, from last one year I am using 
        the pultry raking machine provided by SNA. I am very happy with
        its performance. Previously raking used to be very difficult with
        manual methods, this machine made our job quicler, easier and effective,
        as dialy raking helping in quality yield and keeping the farm bed fresh
        from bad smell and cake formations.`,
        videoId:"DDjpNy8_sAM"
    },
    {
        name:"Ganganna",
        place:"Madhugiri",
        pic:ganganna,
        message:`I own 3.5 acres, of Ragi, Maize, Flowers and Vegetables. I
        used to own oxes, but as an alternative found and purchased SNA's
        e-Kunte. Now I'm able to independently manage my farm, post sowing 
        activities on time and whenever I needed, as it battery driven there
        is hardly Rs.10-15/hour of cost compared to other alternatives that
        costs Rs.300-350/hour.`,
        videoId:"mdyqaW1kRXc"
    },
    {
        name:"Durga Charan",
        place:"Agumbe",
        pic:durga,
        message:`SNA's Raking machine can be used evevn at 35th day,
        able to do effective raking, and it is majorly operated by
        ladies at our farm as it is very handy and easy to use. It
        works for all types of flooring. With one charge, I am able 
        to rake almost ~15,000 sqft effectively, mahcine is providing
        the same efficiency without any issues even after 1 year since
        my purchase.`
        
    },
    {
        name:"Sunil",
        place:"Ballary",
        pic:sunil,
        message:`I am using Single Wheel Weeder for last two years and
        able to manage my 2 acres of my Maize field effectively,
        chemical-free, avoiding weedicides and getting better
        yield. Now got one more weeder for plantations as well.
        Apart from this, I actively promote these machines by
        giving it on rental and demos on request from the fellow
        farmers in our region.`,
        videoId:"5RlDcF3iqwE"
    }
]